import { apiRequest } from "../util/apiUtils";

export const organizationList = async (params) => {
  try {
    const res = await apiRequest("get", `organization/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationListFront = async (params) => {
  try {
    const res = await apiRequest("get", `organization/list-front`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationTeamList = async (params) => {
  try {
    const res = await apiRequest("get", `verification/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const artistTeamStatusChange = async (params) => {
  try {
    const res = await apiRequest("patch", `user/artist/status`, {
      body: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationDetails = async (params) => {
  try {
    const res = await apiRequest("get", `organization/detail/${params?.id}`, {
      queries: {
        ...(params?.type && { type: params?.type }),
      },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationTeamDetails = async (params) => {
  try {
    const res = await apiRequest("get", `verification/detail/${params?.id}`, {
      queries: {
        ...(params?.type && { type: params?.type }),
      },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationTeamDashboard = async (params) => {
  try {
    const res = await apiRequest("get", `organization/promotion/dashboard`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationTeamItem = async (params) => {
  try {
    const res = await apiRequest("get", `order/promoter-pass-event`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationAddEdit = async (payload) => {
  try {
    const requestType = payload?.requestType || "multipart/form-data";
    delete payload?.requestType;
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `organization/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      requestType
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `organization/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `organization/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `organization/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const changeOrganization = async (payload) => {
  try {
    const res = await apiRequest("patch", `organization/change`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const invitation = async (params) => {
  try {
    const res = await apiRequest("patch", `organization/send-invitation`, {
      body: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const invitationEdit = async (params) => {
  try {
    const res = await apiRequest("put", `verification/edit`, {
      body: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const rolePermissionList = async (params) => {
  try {
    const res = await apiRequest("get", `role-permission/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const verificationDetails = async (params) => {
  try {
    const res = await apiRequest("get", `verification/details`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
